import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { RootState } from 'store';
import { selectActiveAudioOutputDevice } from 'user/state';

export const playSound = createAsyncThunk<void, { soundSrc: string; deviceId?: string }>(
  'app/playSound',
  async ({ soundSrc, deviceId: deviceIdOverride }, { getState }) => {
    try {
      const activeAudioOutputDevice = selectActiveAudioOutputDevice(getState() as RootState);
      const deviceId = deviceIdOverride ?? activeAudioOutputDevice?.deviceId;
      const soundSample = new Audio(soundSrc);
      soundSample.volume = 0.3;
      if (deviceId && typeof soundSample?.setSinkId === 'function') {
        await soundSample.setSinkId(deviceId);
      }
      await soundSample.play();
    } catch (e) {
      // Autoplay policy can block playback without a fresh user gesture (e.g. a host who refreshed
      // straight into backstage); that's expected and benign, so stay silent. Surface anything else.
      if ((e as DOMException)?.name !== 'NotAllowedError') {
        logger.error(e);
      }
    }
  }
);
